import ar from "./ar.json"
import de from "./de.json"
import en from "./en.json"
import es from "./es.json"
import fr from "./fr.json"
import ha from "./ha.json"
import hi from "./hi.json"
import id from "./id.json"
import it from "./it.json"
import nl from "./nl.json"
import pl from "./pl.json"
import pt from "./pt.json"
import ru from "./ru.json"
import sw from "./sw.json"
import tr from "./tr.json"
import uk from "./uk.json"
import ur from "./ur.json"
import yo from "./yo.json"
import cn from "./zh.json"


export const countriesInDiffLangs = {
    ar,
    de,
    en,
    es,
    fr,
    ha,
    hi,
    id,
    it,
    nl,
    pl,
    pt,
    ru,
    sw,
    tr,
    uk,
    ur,
    yo,
    cn
}